/**
 * Pure H OS · Phase D Wave 3 · Unified Risk Register (types + live view).
 * MongoDB collection: `pureh_risks_registry`.
 */
import { liveArray } from "../services/store";

export type RiskSeverity = "low" | "medium" | "high";
export type RiskLikelihood = "low" | "medium" | "high";
export type RiskImpact = "low" | "medium" | "high";
export type RiskStatus = "open" | "monitoring" | "mitigated";

export type RiskEntry = {
  id: string;
  title: string;
  module: string;
  severity: RiskSeverity;
  likelihood: RiskLikelihood;
  impact: RiskImpact;
  status: RiskStatus;
  owner: string;
  updatedRelative: string;
  mitigation: string;
  mitigatedByDecisionId?: string;
};

export const RISKS_REGISTRY: RiskEntry[] = liveArray<RiskEntry>("risks_registry");
